// @flow
import React from 'react'
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography
} from '@material-ui/core'
import { isEmpty } from 'lodash/lang'
import { last } from 'lodash/array'
import { defaultTo } from 'lodash/util'
import { get } from 'lodash/object'
import { find } from 'lodash/collection'
import i18n from 'i18next'

import AddressCard from './AddressCard'
import AddressInvoicePicker from './AddressInvoicePicker'
import styles, { Wrapper, TitleBox } from './styles'

type Props = {
  addresses: Array<Object>,
  cartID: number,
  firstAvailableDeliveryService: {
    name: string,
    price: number,
    firstAvailableSlot: {
      day: string
    }
  },
  isDisabled: boolean,
  postDeliveryAddress: Function,
  toggleCanGoToNextStep: Function,
  setInvoiceAddressID: Function,
  language: string,
  navigateTo: Function,
  updateInvoiceData: Function,
  comesFromEditingAddress: string
}

type State = {
  formFields: {
    address: {
      value: string,
      error: boolean,
      isRequired: boolean,
      isValid: Function
    }
  }
}

class AddressPicker extends React.Component<Props, State> {
  state = {
    formFields: {
      address: {
        value: get(last(this.props.addresses), 'id', ''),
        error: false,
        isRequired: true,
        isValid: (address: string) => !isEmpty(address)
      }
    }
  }

  onInputChange: Function = (event: Object) => {
    this.setState({
      formFields: {
        ...this.state.formFields,
        [event.target.name]: {
          ...this.state.formFields[event.target.name],
          value: event.target.value
        }
      }
    })

    this.props.postDeliveryAddress(this.props.cartID, event.target.value)
    this.props.toggleCanGoToNextStep()
  }

  componentDidMount () {
    if (!isEmpty(this.state.formFields.address.value)) {
      this.props.postDeliveryAddress(
        this.props.cartID,
        this.state.formFields.address.value
      )
      this.props.toggleCanGoToNextStep()
    }
  }

  render () {
    return (
      <Grid item xs={12}>
        <TitleBox>{i18n.t('checkout.selectDeliveryAddress')}</TitleBox>
        <Wrapper>
          <form>
            <FormControl
              fullWidth
              margin='normal'
              required={this.state.formFields.address.isRequired}
              variant='outlined'
              error={this.state.formFields.address.error}
              disabled={this.props.isDisabled}
            >
              <InputLabel htmlFor='delivery-address'>
                {i18n.t('checkout.selectDeliveryAddressInput')}
              </InputLabel>
              <Select
                value={this.state.formFields.address.value}
                onChange={this.onInputChange}
                input={
                  <OutlinedInput
                    labelWidth={260}
                    name='address'
                    id='delivery-address'
                  />
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
                }}
              >
                {this.props.addresses.map((address, idx) => (
                  <MenuItem value={address.id} key={idx}>
                    {address.alias}
                  </MenuItem>
                ))}
              </Select>
              {this.state.formFields.address.error && (
                <FormHelperText error>
                  {i18n.t('checkout.error.addressSelect')}
                </FormHelperText>
              )}
            </FormControl>
          </form>

          <Grid item xs={12}>
            <a
              href={`${i18n.t(
                'routes.ACCOUNT_PERSONAL_ADDRESS_ADD'
              )}?comesFrom=checkout`}
              style={styles.link}
            >
              <Typography>
                {i18n.t('checkout.addAnotherDeliveryAddress')}
              </Typography>
            </a>
          </Grid>

          {!isEmpty(this.state.formFields.address.value) && (
            <div style={styles.addressCardMargin}>
              <AddressCard
                address={defaultTo(
                  find(this.props.addresses, [
                    'id',
                    this.state.formFields.address.value
                  ]),
                  {}
                )}
              />
            </div>
          )}

          {!isEmpty(this.state.formFields.address.value) && (
            <AddressInvoicePicker
              addressID={this.state.formFields.address.value}
              addresses={this.props.addresses}
              navigateTo={this.props.navigateTo}
              setInvoiceAddressID={this.props.setInvoiceAddressID}
              updateInvoiceData={this.props.updateInvoiceData}
              comesFromEditingAddress={this.props.comesFromEditingAddress}
            />
          )}
        </Wrapper>
      </Grid>
    )
  }
}

export default AddressPicker
